'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.isUnauthorisedResponse = isUnauthorisedResponse;

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Fetch wrapper with auth token refresh flow support.
 * @access private
 */
exports.default = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(uri) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var response, _text, json;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(uri, (0, _extends3.default)({}, options, {
              headers: (0, _extends3.default)({}, options.headers, (0, _utils.includeAuthHeader)())
            }));

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.text();

          case 5:
            _text = _context.sent;
            json = null;
            _context.prev = 7;

            json = JSON.parse(_text);
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context['catch'](7);
            return _context.abrupt('return', (0, _extends3.default)({}, response, {
              text: function text() {
                return _promise2.default.resolve(_text);
              }
            }));

          case 14:
            if (isUnauthorisedResponse(json)) {
              _context.next = 16;
              break;
            }

            return _context.abrupt('return', (0, _extends3.default)({}, response, {
              text: function text() {
                return _promise2.default.resolve(_text);
              }
            }));

          case 16:
            _context.next = 18;
            return (0, _utils.checkAuth)(uri);

          case 18:
            return _context.abrupt('return', fetch(uri, (0, _extends3.default)({}, options, {
              headers: (0, _extends3.default)({}, options.headers, (0, _utils.includeAuthHeader)())
            })));

          case 19:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[7, 11]]);
  }));

  function fetchWrapper(_x) {
    return _ref.apply(this, arguments);
  }

  return fetchWrapper;
}();

function isUnauthorisedResponse(json) {
  // see https://gitlab.quiqup.com/liveops/tom/wikis/Authentication-&-Authorisation#error-messages
  return json && json.errors && json.errors[0] && json.errors[0].message === 'unauthenticated';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/network/graph-client/graph-fetch-wrapper.js
// module id = 446
// module chunks = 0